import { query } from "./strapi";

export const getOrderByGeneratedId = async (
  email: string,
  generatedOrderId: string
): Promise<{ orderData?: any; message?: string }> => {
  try {
    // **KEEP: Using GET with query parameters to match the route configuration**
    const data = await query(
      `orders/lookup?email=${encodeURIComponent(
        email.trim()
      )}&generatedOrderId=${encodeURIComponent(generatedOrderId.trim())}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );

    // Handle the response structure from backend
    if (data && (data.orderId || data.generatedOrderId)) {
      return { orderData: data };
    } else {
      console.error("Invalid response structure:", data);
      return {
        message:
          "Respuesta inválida del servidor. Por favor, inténtalo de nuevo.",
      };
    }
  } catch (error: any) {
    console.error("Error fetching order:", error);

    // Handle API errors consistently
    if (error.message && error.message.includes("404")) {
      return {
        message:
          "Pedido no encontrado. Verifica que el número de orden y correo electrónico sean correctos.",
      };
    }

    if (error.message && error.message.includes("400")) {
      return {
        message:
          "Datos inválidos. Verifica que el número de orden y correo electrónico sean correctos.",
      };
    }

    return {
      message:
        "Error de conexión. Por favor, verifica tu conexión a internet e inténtalo de nuevo.",
    };
  }
};
